import slideDown from '../animation/slideDown';
import slideActiveFirstPanel from '../form_wizard/animation/slideActiveFirstPanel';
import 'element-closest-polyfill';

// Gets the leadform panel ID an element belongs to
export function getLeadFormPanelId(el){
  const panel  = el.closest('.lead-constructor__panel');
  if (!panel) { return undefined; }
  return panel.dataset.id;
}

// Gets the leadform ID an element belongs to
export function getLeadFormId(el){
  const form = el.closest('form');
  if (!form) { return undefined; }
  const leadform = form.querySelector('input[name="leadform"]');
  if (!leadform) { return undefined; }
  return leadform.value;
}

const leadformIsDeferred = (el) => (
  el.dataset.markup && !el.innerHTML
);

function writeDeferredLeadform(el) {
  el.innerHTML = el.dataset.markup;
  el.dataset.markup = '';
  setTimeout(function() {
    if(el.dataset.js) {
      el.dataset.js.split(', ').forEach((src) => {
        if(src) {
          const script = document.createElement('script');
          script.src = src.split('|')[0];
          script.integrity = src.split('|')[1];
          script.crossOrigin = 'anonymous';
          document.head.appendChild(script);
        }
      });
    }
  }, 100);
}

export function openLeadform(el) {
  // If we have an active panel, slide it in
  slideActiveFirstPanel(el);

  // If 'minimize: true' is set in the lead_form params
  if (el.dataset.minimize) {
    slideDown(el);
  }

  // For 'deferred' leadforms, write the entire HTML contents now
  if (leadformIsDeferred(el)) {
    writeDeferredLeadform(el);
  }

  // If 'replace: selector' is set in the lead_form params
  if(el.dataset.replace) {
    const oldElement = document.querySelector(el.dataset.replace);

    if(oldElement) {
      oldElement.classList.add('leadform-replace-target--hidden');
      el.classList.remove('leadform--hidden');
    }
  }
}
